<!-- Intro -->
<section class="intro">
  @if (content?.intro.text) {
    <div
      class="intro-text _title--large"
      [innerHTML]="content?.intro.text"
    ></div>
  }
  <div class="intro-links">
    @if (content?.intro.linkLabel && content?.intro.linkUrl) {
      <a
        href="{{ content?.intro.linkUrl }}"
        class="intro-link _button--medium _button--outline"
        >{{ content?.intro.linkLabel }}</a
      >
    }
    @if (content?.intro.link2Label && content?.intro.link2Url) {
      <a
        href="{{ content?.intro.link2Url }}"
        class="intro-link _button--medium _button--outline"
        >{{ content?.intro.link2Label }}</a
      >
    }
  </div>
</section>

<!-- Lists -->
@for (list of content?.lists; track list; let i = $index) {
  <ul class="list">
    @for (item of list; track item) {
      <li class="list-li">
        @if (item.link) {
          <a href="{{ item.link }}" [attr.target]="item.target || null">{{
            item.label
          }}</a>
        }
        @if (item.routerLink) {
          <a [routerLink]="item.routerLink">{{ item.label }}</a>
        }
        @if (!(item.link || item.routerLink)) {
          <span>{{ item.label }}</span>
        }
      </li>
    }
    @if (i === content?.lists.length - 1) {
      @if (cookiesInited) {
        <li class="list-li">
          <button onclick="CookieFirst.openPanel();">cookies</button>
        </li>
      }
      @if (!copyrightLong) {
        <li>
          <span>© {{ dateNow | date: "Y" }} {{ siteTitle }}</span>
        </li>
      }
    }
  </ul>
}

<!-- <li [class.language--selected]="localeId === 'nl-be'"><a href="/platform{{currentURLForSwitching}}" i18n>Nederlands</a></li>
      <li [class.language--selected]="localeId === 'en'"><a href="/platform/en{{currentURLForSwitching}}" i18n>English</a></li> -->

<!-- Logos -->
@if (content?.logos?.length) {
  <ul class="logos">
    @for (logo of content?.logos; track logo) {
      <li class="logo">
        @if (logo.link) {
          <a
            class="logo-link"
            href="{{ logo.link }}"
            target="_blank"
            rel="noopener"
            ><ng-template *ngTemplateOutlet="logoImage"></ng-template
          ></a>
        }
        @if (!logo.link) {
          <div class="logo-unlink">
            <ng-template *ngTemplateOutlet="logoImage"></ng-template>
          </div>
        }
        <ng-template #logoImage>
          <img
            class="logo-image"
            alt="{{ logo.label }}"
            title="{{ logo.label }}"
            loading="lazy"
            src="{{ logo.image }}"
          />
        </ng-template>
      </li>
    }
  </ul>
}

@if (copyrightLong) {
  <p class="copyrightLong">
    © {{ dateNow | date: "Y" }} {{ siteTitle }}{{ copyrightLong }}
  </p>
}
